export const getContractManagementItemUrl = (id: string | number) => `/sales/contract-management/${id}/`;
export default getContractManagementItemUrl;
